<div style="width: 408px">
  <app-add-profile
    (onClose)="close()"
    (editSkills)="editSkillsClicked($event)"
    (onProfileChange)="profileChange($event)"
    *ngIf="step === 0"
    [activeSkills]="data.updateSkills"
    [profile]="data.profile"
    [openType]="this.data.openType"
    [type]="data.type"
    [topAccessOptions]="topAccessOptions"
    [formationsGroup]="data.formationsGroup"
  >
  </app-add-profile>
</div>

<app-intialize-profile-skills
  (skillsValidation)="SkillsValidation($event)"
  *ngIf="step === 1"
  [profile]="data.profile"
  [openType]="this.data.openType"
  (onClose)="close()"
>
</app-intialize-profile-skills>

<!-- <div class="spinnerContainer" *ngIf="isLoading" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
</div> -->
